import UploadImageFormFields from '@Containers/UploadImageFormFields';
import { Box } from '@mui/material';
import { StakeholderAnalysisFormValues } from '../ImpactsOnStakeholdersFormProvider/types';
import { useWatch } from 'react-hook-form';

const StakeholderAnalysisUploadImage = () => {
  const { completedSection } =
    useWatch({
      name: 'stakeholderAnalysis',
    }) ?? ({} as StakeholderAnalysisFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <Box mt={2}>
      <UploadImageFormFields
        title={
          'รูปภาพรายละเอียดการวิเคราะห์ผู้มีส่วนได้เสียในห่วงโซ่คุณค่าธุรกิจ'
        }
        name={`stakeholderAnalysis`}
        disabledTh={isCompletedTh}
        disabledEn={isCompletedEn}
      />
    </Box>
  );
};

export default StakeholderAnalysisUploadImage;
